import styled from 'styled-components';

import { Colors } from 'modules/ui/theme/colors';

export const FormContainer = styled.div`
  padding: 16px;
`;

export const DragAndDropContainer = styled.div`
  margin-top: 16px;
`;

export const BoatSelectRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
`;

export const BoatSelect = styled.select`
  flex: 1;
  height: 40px;
  border: 1px solid ${Colors.Gray};
  border-radius: 4px;
  padding: 8px 12px;
  outline: none;
  box-sizing: border-box;
  cursor: pointer;
  background: ${Colors.White};
`;

export const MultiRow = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  margin-top: 24px;
  align-items: center;
  > div {
    margin-right: 24px;
  }
`;
